import {binder} from "./libs/binder";
import "./libs/slick"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {headerSearch} from "./modules/headerSearch";
import {footerMobileMenu} from "./modules/footerMobileMenu";
import {animationOnScroll} from "./modules/animationOnScroll";
import {customSelect} from "./modules/customSelect";
import {solutionSlider} from "./modules/solutionSlider";
import {accordion} from "./modules/accordion";
import {solutionCardsSlider} from "./modules/solutionCardsSlider";
import {resourcesListSlider} from "./modules/resourcesListSlider";
import {videoHover} from "./modules/videoHover";
import {parallax} from "./modules/parallax";
import {textAnimation} from "./modules/textAnimation";
import {videoPlayOnScroll} from "./modules/videoPlayOnScroll";
import {tabs} from "./modules/tabs";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {tableWrap} from "./modules/tableWrap";
import {contactsForm} from "./modules/contactsForm";
import {awardsSlider} from "./modules/awardsSlider";
import {roiCalculator} from "./modules/roiCalculator";
import {historySlider} from "./modules/historySlider";
import {cardsCarousel} from "./modules/cardsCarousel";
import {article} from "./modules/article";
import {heroVideo} from "./modules/heroVideo";
import {awardsHistory} from "./modules/awardsHistory";
import {anchors} from "./modules/anchors";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";


binder({
    bounds: {
        html: [constants, fullHeightPage],
        ".header": [stickyHeader, mobileNav, headerSearch],
        ".footer .footer-nav": footerMobileMenu,
        ".has-animation": animationOnScroll,
        "select": customSelect,
        ".solutions-list.has-slider": solutionSlider,
        ".accordion": accordion,
        ".solutions-cards.has-slider": solutionCardsSlider,
        ".resources-list.has-slider": resourcesListSlider,
        ".has-video": videoHover,
        ".has-parallax": parallax,
        ".text-animation": textAnimation,
        "video.play-on-scroll": videoPlayOnScroll,
        ".tabs-holder": tabs,
        ".testimonials-slider": testimonialsSlider,
        "table": tableWrap,
        "#pardotForm": contactsForm,
        ".awards-slider-holder": awardsSlider,
        ".roi-calculator-section": roiCalculator,
        ".history-section": historySlider,
        ".cards-carousel-wrap": cardsCarousel,
        ".article.content": article,
        ".hero-bg video": heroVideo,
        ".awards-history": awardsHistory,
        ".has-anchor": anchors,
        ".copy-link": copyLinkToBuffer,
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js